import BenefitGroupForm from './BenefitGroupForm'

export default BenefitGroupForm
